/**
 * 6-max Opening Ranges by Position - Compact Grid Format
 *
 * Shows the earliest position from which each hand should be opened.
 * Categories represent: SB (widest) → BTN → CO → HJ → UTG (tightest)
 *
 * Note: This is a simplified model. Actual GTO ranges are more nuanced.
 */

import type { ChartData } from '@/types/chart';

export const sixMaxOpeningData: ChartData = {
  version: 1,
  name: '6-Max Opening Ranges',
  description: 'Earliest position to open each hand (UTG = tightest, SB = widest)',
  categoryMapping: {
    categories: ['UTG', 'HJ', 'CO', 'BTN', 'SB'],
    direction: 'descending',
  },
  hands: [
    // Row 0 (A): AA    AKs   AQs   AJs   ATs   A9s   A8s   A7s   A6s   A5s   A4s   A3s   A2s
    ['UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'UTG'],

    // Row 1 (K): AKo   KK    KQs   KJs   KTs   K9s   K8s   K7s   K6s   K5s   K4s   K3s   K2s
    ['UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'HJ', 'HJ', 'CO', 'CO', 'CO', 'BTN', 'BTN', 'BTN'],

    // Row 2 (Q): AQo   KQo   QQ    QJs   QTs   Q9s   Q8s   Q7s   Q6s   Q5s   Q4s   Q3s   Q2s
    ['UTG', 'UTG', 'UTG', 'UTG', 'UTG', 'HJ', 'CO', 'BTN', 'BTN', 'BTN', 'SB', 'SB', 'SB'],

    // Row 3 (J): AJo   KJo   QJo   JJ    JTs   J9s   J8s   J7s   J6s   J5s   J4s   J3s   J2s
    ['UTG', 'HJ', 'HJ', 'UTG', 'UTG', 'HJ', 'CO', 'BTN', 'SB', 'SB', 'SB', 'SB', 'SB'],

    // Row 4 (T): ATo   KTo   QTo   JTo   TT    T9s   T8s   T7s   T6s   T5s   T4s   T3s   T2s
    ['UTG', 'CO', 'CO', 'CO', 'UTG', 'UTG', 'CO', 'BTN', 'BTN', 'SB', 'SB', 'SB', 'SB'],

    // Row 5 (9): A9o   K9o   Q9o   J9o   T9o   99    98s   97s   96s   95s   94s   93s   92s
    ['BTN', 'BTN', 'BTN', 'BTN', 'BTN', 'UTG', 'HJ', 'CO', 'BTN', 'BTN', 'SB', null, null],

    // Row 6 (8): A8o   K8o   Q8o   J8o   T8o   98o   88    87s   86s   85s   84s   83s   82s
    ['BTN', 'SB', 'SB', 'SB', 'SB', 'BTN', 'UTG', 'HJ', 'CO', 'BTN', 'SB', null, null],

    // Row 7 (7): A7o   K7o   Q7o   J7o   T7o   97o   87o   77    76s   75s   74s   73s   72s
    ['BTN', 'SB', 'SB', 'SB', 'SB', 'SB', 'SB', 'UTG', 'HJ', 'CO', 'SB', 'SB', null],

    // Row 8 (6): A6o   K6o   Q6o   J6o   T6o   96o   86o   76o   66    65s   64s   63s   62s
    ['BTN', 'SB', 'SB', null, null, null, 'SB', 'SB', 'UTG', 'UTG', 'BTN', 'SB', null],

    // Row 9 (5): A5o   K5o   Q5o   J5o   T5o   95o   85o   75o   65o   55    54s   53s   52s
    ['BTN', 'SB', 'SB', null, null, null, null, 'SB', 'SB', 'UTG', 'HJ', 'BTN', 'SB'],

    // Row 10 (4): A4o   K4o   Q4o   J4o   T4o   94o   84o   74o   64o   54o   44    43s   42s
    ['BTN', 'SB', null, null, null, null, null, null, 'SB', 'SB', 'HJ', 'BTN', 'SB'],

    // Row 11 (3): A3o   K3o   Q3o   J3o   T3o   93o   83o   73o   63o   53o   43o   33    32s
    ['SB', null, null, null, null, null, null, null, null, null, null, 'CO', 'SB'],

    // Row 12 (2): A2o   K2o   Q2o   J2o   T2o   92o   82o   72o   62o   52o   42o   32o   22
    ['SB', null, null, null, null, null, null, null, null, null, null, null, 'CO'],
  ],
};
